import React from 'react'
import PropTypes from 'prop-types'
import { HStack, Progress, Text } from '@chakra-ui/react'

function ProgressBar({ loading, hasContent }) {
  return (
    <HStack w="100%">
      <Text>0%</Text>
      <Progress
        w="100%"
        isIndeterminate={loading}
        value={!hasContent ? 0 : 100}
      />
      <Text>100%</Text>
    </HStack>
  )
}

ProgressBar.propTypes = {
  hasContent: PropTypes.bool,
  loading: PropTypes.bool,
}

export default ProgressBar
